module.exports = __webpack_public_path__ + "static/media/Vodka con fresa y chía.608b5a43.webp";